export const login = {
    header: "تسجيل الدخول",
    items: {
        username: {
            placeholder: "ادخل اسم المستخدم",
            label: "اسم المستخدم",
            type: "text",
        },
        password: {
            placeholder: "أدخل كلمة المرور",
            label: "كلمة المرور",
            type: "password",
        },
    },
    submit: {
        placeholder: "يُقدِّم",
        label: "يُقدِّم",
        type: "submit",
    },
    cancel: {
        label: "يلغي",
    },
};
